'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _format = require('../../helpers/format');

var _format2 = _interopRequireDefault(_format);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _components = require('../../components');

var _TargetDateLinks = require('./TargetDateLinks.css');

var _TargetDateLinks2 = _interopRequireDefault(_TargetDateLinks);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TargetDateLinks = (_dec = (0, _reactCssModules2.default)(_TargetDateLinks2.default, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(TargetDateLinks, _Component);

  function TargetDateLinks(props) {
    (0, _classCallCheck3.default)(this, TargetDateLinks);

    var _this = (0, _possibleConstructorReturn3.default)(this, (TargetDateLinks.__proto__ || (0, _getPrototypeOf2.default)(TargetDateLinks)).call(this, props));

    _this.makeUrl = function (fund) {
      var sName = _format2.default.sanitize(fund.fund_legal_name);
      var sTicker = fund.ticker || 'N';
      return _config2.default.routes.fund + '/' + sName + '/' + sTicker + '/' + _config2.default.profilePath + '/' + fund.fund_id + '/' + fund.investment_vehicle_id;
    };

    _this.hasFunds = function () {
      return _this.props.funds && Array.isArray(_this.props.funds) && _this.props.funds.length > 0;
    };

    _this.state = {
      gradeField: {
        'Fossil Free Funds': 'grade_fossil',
        'Deforestation Free Funds': 'grade_deforestation',
        'Gender Equality Funds': 'grade_gender_equality',
        'Gun Free Funds': 'grade_guns',
        'Prison Free Funds': 'grade_prison_industrial_complex',
        'Weapon Free Funds': 'grade_military',
        'Tobacco Free Funds': 'grade_tobacco'
      }[_config2.default.app.title] || 'undefined'
    };
    return _this;
  }
  //

  //


  (0, _createClass3.default)(TargetDateLinks, [{
    key: 'render',

    //
    value: function render() {
      var _this2 = this;

      if (!this.hasFunds()) {
        return _react2.default.createElement('div', { styleName: 'td-fund-years-wrap' });
      }
      return _react2.default.createElement(
        'div',
        { styleName: 'td-fund-years-wrap' },
        this.props.funds.map(function (e, i) {
          var nameYear = e.fund_legal_name.match(/ 20\d{2}/);
          var eUrl = _this2.makeUrl(e);
          return _react2.default.createElement(
            _components.Link,
            {
              key: _this2.props.strategyName + nameYear + ' ' + i,
              to: eUrl,
              title: _this2.props.strategyName + nameYear + ' | ' + _config2.default.app.title
            },
            _react2.default.createElement(
              'div',
              { styleName: 'td-fund-year grade-' + e[_this2.state.gradeField] },
              nameYear ? nameYear[0] : null
            )
          );
        })
      );
    }
  }]);
  return TargetDateLinks;
}(_react.Component), _class2.propTypes = {
  strategyName: _react.PropTypes.string,
  funds: _react.PropTypes.array
}, _temp)) || _class);
exports.default = TargetDateLinks;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/core/TargetDateLinks/TargetDateLinks.js
// module id = 1395
// module chunks = 0